"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _KnockNotificationItem = require("./KnockNotificationItem");
Object.keys(_KnockNotificationItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _KnockNotificationItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _KnockNotificationItem[key];
    }
  });
});